export const getPriceWithout = (prices: Array<any | null> | null, currency: GQL.ICurrency) => {
  if (prices) {
    const price = prices.find((p: any) => p.currencyId && p.currencyId === currency.id);
    if (price && price.priceWithout) {
      return price.priceWithout;
    }
  }

  return null;
}


// WEBPACK FOOTER //
// ./src/helpers/Prices/getPrice.ts